module.exports = require("./sr-Latn-XK.d.ts");